import React from "react";
import {
  Card,
  Divider,
  DecoratedImage,
  Typography,
} from "@dreambigger/design-system/src/components";
import { CardActions } from "@dreambigger/shared/src/components/board/feed-cards/card-components";
import { Community } from "@dreambigger/shared/src/types";
import hover from "../../styles/hover.module.scss";
import anim from "@dreambigger/shared/src/components/board/styles/animations.module.scss";
import { useRouter } from "next/router";
import InspireAnalytics, {
  InspireAnalyticsHelper,
  InspireAnalyticEvents,
} from "@dreambigger/shared/src/utils/inspire-analytics-helper";
import { useGA, useMixpanel, useSegment } from "@dreambigger/shared/src/hooks";
import truncate from "truncate";

const { Title } = Typography;

type SubCommunityProps = {
  subCommunity: Community;
};

const SubCommunityCard = ({ subCommunity }: SubCommunityProps) => {
  const { meta, title, slug } = subCommunity;

  const router = useRouter();

  //Load Analytics
  const googleAnalytics = useGA();
  const mixpanel = useMixpanel();
  const segment = useSegment();

  // Get the subtitle to display underneath the title.
  const subtitle = meta?.stats?.subtitle;

  // Get the image to display on the card.
  const image = meta?.stats?.image;

  // Get the communityUrl to lead the user to upon clicking the cta.
  const subCommunityUrl = `/community/${slug}/detail`;

  const handleSubCommunityClick = () => {
    router.push(subCommunityUrl);
  };

  const handleCardClick = () => {
    // Handle the analytics event where a user clicks the card.
    googleAnalytics.event({
      category: "Card Selection",
      action: "CTA Text:View Community",
      label: "Card Type:Sub-Community",
      value: 1,
    });
    InspireAnalytics.track({
      eventName: InspireAnalyticEvents.CARD_SELECTED,
      properties: {
        "Card Type": "SubCommunity",
        "Page Type": InspireAnalyticsHelper.getPageType(router.route),
      },
      mixpanel,
      segment,
    });
  };

  return (
    <Card
      onClick={handleCardClick}
      bodyStyle={{ padding: 0 }}
      className={`${hover.lift} ${anim.enter_f} mh-auto bg-white pointer`}
      cover={
        <DecoratedImage
          alt="SubCommunity Img"
          src={image || ""}
          onClick={handleSubCommunityClick}
        />
      }
    >
      {/* CONTENT ------------------------------------------------ */}
      <div onClick={handleSubCommunityClick}>
        <div className="ph-5 pv-4" style={{ minHeight: "130px" }}>
          <Title level={4} className="lh-3">
            {title}
          </Title>
          {subtitle && (
            <p className="mb-0" style={{ minHeight: "60px" }}>
              {truncate(subtitle, 190)}
            </p>
          )}
        </div>
      </div>
      <Divider />
      {/* CARD ACTIONS BAR -------------------------------------- */}
      <CardActions
        ctaTitle="View Community"
        ctaLink={subCommunityUrl}
        likeEnabled={false}
      />
    </Card>
  );
};

export default SubCommunityCard;
